"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTINGS_FRAGMENT = void 0;
const helpers_1 = require("../../client/helpers");
exports.SETTINGS_FRAGMENT = `
  fragment SettingsFragment on Settings {
    defaultChannelId
    currency
    defaultPricing {
      type
      price
      period
      enabled
    }
    extendOptions
    embedLogos {
      selected
      default
    }
  }
`;
//# sourceMappingURL=settings.fragments.js.map